import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { globalSettingsLayout } from '@atlassian/jira-global-settings-layout/src/index.tsx';
import AsyncSidebarGlobalSettingsProjects from '@atlassian/jira-navigation-apps-sidebar-global-settings-projects/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { getNavigationResources } from '@atlassian/jira-router-resources-navigation/src/index.tsx';
import { projectsDirectoryManageRootRedirectRoute } from '@atlassian/jira-router-routes-directories-routes/src/projectsDirectoryManageRootRedirectRoute.tsx';
import { ProjectsDirectorySkeleton } from '@atlassian/jira-skeletons/src/ui/directories/FiltersDirectorySkeleton.tsx';
import { ProjectsDirectoryManageRedirect } from './ui/ProjectsDirectoryManageRedirect.tsx';
import { adminProjectDirectoryResources } from './common/adminProjectDirectoryResources.tsx';
import { LazyProjectsDirectory } from './common/LazyProjectsDirectory.tsx';

export const projectsDirectoryManageRootRedirectRouteEntry = createEntry(
	projectsDirectoryManageRootRedirectRoute,

	() => ({
		component: ProjectsDirectoryManageRedirect,
		skeleton: ProjectsDirectorySkeleton,
		isRedirect: true,
		layout: globalSettingsLayout,

		navigation: {
			sidebar: AsyncSidebarGlobalSettingsProjects,
		},

		resources: [...getNavigationResources(), ...adminProjectDirectoryResources()],
		forPaint: [LazyAtlassianNavigation, LazyProjectsDirectory],

		bifrost: {
			bifrostGroup: 'shell-only',

			bundling: {
				packageName:
					'@atlassian/jira-router-routes-directories-entries/src/projectsDirectoryManageRootRedirectRouteEntry.tsx',
				whichExportToUse: 'projectsDirectoryManageRootRedirectRouteEntry',
			},

			enabled: true,
		},
	}),
);
